import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { PARTY_ROLE_CHANGES } from '../../constants/tableTypes'

const initialState = {
  data: [],
}

const partyRoleHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${PARTY_ROLE_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        PARTY_ROLE_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(PARTY_ROLE_CHANGES)(
        state,
        action
      )
  }
}

export default combineReducers({
  data: partyRoleHistoryReducer,
  tableInfo: reducers.auditTableColumnDefinitions(PARTY_ROLE_CHANGES),
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(PARTY_ROLE_CHANGES, state, action),
})
